import { FlakyTest } from "../../shared/type";
import FlakyTestRow, { FlakyRowProps } from "../FlakyTestRow";

type Props = FlakyRowProps & {
  flakyTests: FlakyTest[];
};

const FlakyTestTable = ({
  flakyTests,
  currentAccountMember,
  teams,
  isAdmin,
  flakyTestAssignmentFeatureAvailable,
  organizationSettingsUrl,
  refreshAssignments,
  isFlaky,
}: Props) => {
  return (
    <section>
      <ul className="ta-card__container">
        <li
          aria-hidden={true}
          className="ta-card__container--heading col-12 mb1 px3"
        >
          <div className="pr3 pt2 main-section">Description</div>
          <div className="pr3 pt2 right-align" style={{ width: "6rem" }}>
            Instances
          </div>
          <div className="pt2" style={{ width: "18rem" }}>
            Most recent instance
          </div>
        </li>

        {flakyTests.map((flakyTest) => (
          <li key={flakyTest.test_id} className="col-12 p1 row-link__container">
            <FlakyTestRow
              flakyTest={flakyTest}
              currentAccountMember={currentAccountMember}
              teams={teams}
              isAdmin={isAdmin}
              flakyTestAssignmentFeatureAvailable={
                flakyTestAssignmentFeatureAvailable
              }
              organizationSettingsUrl={organizationSettingsUrl}
              refreshAssignments={refreshAssignments}
              isFlaky={isFlaky}
            />
          </li>
        ))}
      </ul>
    </section>
  );
};

export default FlakyTestTable;
